import { isUserResponseDTO, UserResponseApi } from "../User";
import {
  GroupWithStudentsAndModulesResponseApi,
  isGroupWithStudentsAndModulesResponseDTO,
} from "./Group";
import {
  GroupLearningPathResponseApi,
  isGroupLearningPathResponseDTO,
} from "./GroupLearningPath";

export interface UserWithGroupsResponseApi extends UserResponseApi {
  userGroupLearningPaths: GroupLearningPathResponseApi[];
  userGroups: GroupWithStudentsAndModulesResponseApi[];
}

export let isUserWithGroupsResponseDTO = (
  variable: unknown
): variable is UserWithGroupsResponseApi => {
  return (
    isUserResponseDTO(variable) &&
    "userGroupLearningPaths" in variable &&
    Array.isArray(variable.userGroupLearningPaths) &&
    variable.userGroupLearningPaths.reduce(
      (
        doArrayConsistOfUserGroupLearningPaths,
        userGroupLearningPath: unknown
      ) =>
        doArrayConsistOfUserGroupLearningPaths &&
        isGroupLearningPathResponseDTO(userGroupLearningPath),
      true
    ) &&
    "userGroups" in variable &&
    Array.isArray(variable.userGroups) &&
    variable.userGroups.reduce(
      (doArrayConsistOfUserGroups, userGroup: unknown) =>
        doArrayConsistOfUserGroups &&
        isGroupWithStudentsAndModulesResponseDTO(userGroup),
      true
    )
  );
};
